// @flow strict

export const API_ERROR_CODES = {
  InvalidUserCredentials: 'InvalidUserCredentials',
};
